export default __webpack_public_path__ + "bca5eb955faa4e56a903c153e8dd7405.svg";